import styles from "./Popup.module.css"
import CloseButton from "../../../../components/Button/CloseButton/CloseButton";
import { useTranslation } from "react-i18next";
import { LosePriceRow } from "../../../../types/terms";
import { useEffect } from "react";
import { handleBackgroundScroll } from "../../../../utils/backgroundScroll";
/**
* Props for the Popup component.
*/ 
interface PopupProps{
    onClose?: ()=>void, // Popup close handler
    display?: boolean, // Whether to display popup
    className?:string, // Optional additional class
    cardClassName?:string // Optional additional card class
}
/**
* A popup with info about lose compensation prices of items
*
* @param props PopupProps
* @param {() => void} props.onClose - Popup close handler
* @param {boolean} props.display - Whether to display popup
* @param {string} props.className - Optional additional class
* @param {string} props.cardClassName - Optional additional card class
* @returns TSX.Element
*/
const Popup = ({onClose,  cardClassName, display, className}:PopupProps) => {
    const { t } = useTranslation(); // Translation
    const losePriceList = t("terms.popup.table.rows", { returnObjects: true }) as LosePriceRow[]; // Lose compensation price data

    // Stop scroll on open
    useEffect(()=>{
        if(display === undefined) return
        handleBackgroundScroll(display)
    }, [display])

    return(
        <>
        <div className={`${display ? styles.Popup : styles.PopupHidden} ${className || ''}`}>
            <div className={styles.PopupBg} onClick={onClose}></div>
            <div className={`${styles.PopupCard} ${cardClassName || ''}`}>
                <CloseButton onClick={onClose ?? (() => {})} className={styles.ClosePopup}/>
                <p className={styles.PopupTitle}>{t("terms.popup.title")}</p>
                <div className={styles.BaseTable}>
                    <div className={`${styles.BaseTableRow} ${styles.HeaderRow}`}>
                        <div className={styles.BaseTableCell}><p>{t("terms.popup.table.header1")}</p></div>
                        <div className={styles.BaseTableCell}><p>{t("terms.popup.table.header2")}</p></div>
                    </div>
                    {losePriceList.map((item, index)=>(
                        <>
                        <div className={styles.BaseTableRow}>
                            <div className={styles.BaseTableCell}><p>{item.label}</p></div>
                            <div className={styles.BaseTableCell}><p>{item.price}</p></div>
                        </div>
                        </>
                    ))}
                </div>
            </div>
        </div>
        </>
    )
};

export default Popup;
